import { Injectable } from '@angular/core';
import {
  HttpInterceptor,
  HttpRequest,
  HttpHandler,
  HttpEvent,
} from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';

@Injectable()
export class AuthInterceptor implements HttpInterceptor {
  intercept(
    req: HttpRequest<any>,
    next: HttpHandler
  ): Observable<HttpEvent<any>> {
    if (req.url.startsWith('/assets/i18n')) {
      return next.handle(req); // Skip adding base URL
    }

    // Clone the request and add the base URL
    // const baseUrl = environment.APIUrl;
    // const clonedRequest = req.clone({ url: `${baseUrl}${req.url}` });

    return next.handle(req);
  }
}
